import { Directive, Input, OnInit, inject } from '@angular/core'
import {
  ElderEnumTranslationService,
  ElderSelectComponent,
  TranslatedEnumValue,
} from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { Property } from '../../../../properties/property'
import { PropertyService } from '../../../../properties/property.service'
import { ConstraintOperator } from '../constraint-operator'

@Directive({
  selector: '[appConstraintOperatorSelect]',
})
export class ConstraintOperatorSelectDirective implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly productProperty$ = new BehaviorSubject<Property | null>(null)
  private select = inject(ElderSelectComponent)
  private productPropertyService = inject(PropertyService)

  @Input()
  public set currentSelectedProperty(productProperty: Property) {
    this.productProperty$.next(productProperty)
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'skillSets.constraints.operator'
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = enumTranslationService.enumDataSource(
      ConstraintOperator,
      'ConstraintOperator',
      false
    )
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycles                                                             *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    this.select.isOptionDisabledFn = (operator: TranslatedEnumValue) => {
      const currentProperty: Property | null = this.productProperty$.getValue()
      if (!!currentProperty) {
        // missing if no property was chosen yet
        return !this.productPropertyService
          .getAvailableOperators(currentProperty)
          .some((ao) => ao === operator.value)
      } else {
        return true
      }
    }
  }
}
